"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitArrIntoPairs = void 0;
var splitArrIntoPairs = function (arr) {
    var result = [];
    for (var i = 0; i < arr.length; i += 2) {
        var pair = arr.slice(i, i + 2);
        result.push(pair);
    }
    return result;
};
exports.splitArrIntoPairs = splitArrIntoPairs;
